export default __webpack_public_path__ + "static/media/tutorial-find-link-2.d73fbc63.png";